<template>
    <div class="modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Crear plantilla de turno</h5>
                    <button type="button" class="close" @click="closeModal">&times;</button>
                </div>
                <form @submit.prevent="createShiftTemplate">
                    <div class="modal-body">
                        <div class="form-group">
                            <label for="production-line-input">Línea de producción:</label>
                            <select
                                v-model="formDataShiftTemplate.production_line_id"
                                id="production-line-input"
                                class="form-control"
                                required
                            >
                                <option value="0" disabled>Seleccione una línea de producción</option>
                                <option
                                    v-for="line in productionLines"
                                    :key="line.value"
                                    :value="line.value"
                                >
                                    {{ line.text }}
                                </option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="weekday-input">Día de la semana:</label>
                            <select
                                v-model="formDataShiftTemplate.weekday_id"
                                id="weekday-input"
                                class="form-control"
                                required
                            >
                                <option value="0" disabled>Seleccione un día de la semana</option>
                                <option
                                    v-for="day in weekdays"
                                    :key="day.value"
                                    :value="day.value"
                                >
                                    {{ day.text }}
                                </option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="start-time-input">Hora de inicio:</label>
                            <input
                                type="time"
                                v-model="formDataShiftTemplate.start_time"
                                id="start-time-input"
                                class="form-control"
                                required
                            >
                        </div>
                        <div class="form-group">
                            <label for="end-time-input">Hora de fin:</label>
                            <input
                                type="time"
                                v-model="formDataShiftTemplate.end_time"
                                id="end-time-input"
                                class="form-control"
                                required
                            >
                        </div>
                        <div class="form-group">
                            <label for="description-input">Descripción:</label>
                            <textarea
                                v-model="formDataShiftTemplate.description"
                                id="description-input"
                                class="form-control"
                                required
                            ></textarea>
                        </div>
                    </div>
                    <div class="modal-footer" style="display: flex; justify-content: end;">
                        <button type="button" class="btn btn-danger me-2" @click="closeModal">
                            Cancelar
                        </button>
                        <button type="submit" class="btn btn-success">
                            Crear
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from '../../../common/utils';

export default {
    name: "ShiftTemplateCreateModal",
    data() {
        return {
            productionLines: [],
            weekdays: [],
            formDataShiftTemplate: {
                production_line_id: -1,
                weekday_id: '',
                start_time: '',
                end_time: '',
                description: ''
            },
        };
    },
    methods: {
        getProductionLines() {
            axios.get('/api/production-line')
                .then(response => {
                    this.productionLines = response.data.map(productionLine => {
                        return {
                            value: productionLine.id,
                            text: productionLine.name
                        };
                    });
                })
                .catch(error => {
                    console.log(error);
                    showCustomErrorSweetAlert(error.response.data);
                });
        },
        getWeekdays() {
            axios.get('/api/weekday')
                .then(response => {
                    this.weekdays = response.data.map(weekday => {
                        return {
                            value: weekday.id,
                            text: weekday.name
                        };
                    });
                })
                .catch(error => {
                    console.log(error);
                    showCustomErrorSweetAlert(error.response.data);
                });
        },
        createShiftTemplate() {
            axios.post('/api/shifts-template', this.formDataShiftTemplate)
                .then(response => {
                    showCustomSuccessSweetAlert('Plantilla de turno creada correctamente');
                    this.$emit('shift-template-created');
                    this.closeModal();
                })
                .catch(error => {
                    console.log(error);
                    showCustomErrorSweetAlert(error.response.data);
                })
        },
        closeModal() {
            this.$emit('close-modal');
        },
    },
    mounted() {
        this.getProductionLines();
        this.getWeekdays();
    },
};
</script>